'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dType from "./mealorama.-Meal-Type.js";
import * as $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00241 from "./mealorama.-Meal-Type$$anon$1.js";
import * as $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00242 from "./mealorama.-Meal-Type$$anon$2.js";
import * as $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00243 from "./mealorama.-Meal-Type$$anon$3.js";
import * as $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00244 from "./mealorama.-Meal-Type$$anon$4.js";
import * as $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00245 from "./mealorama.-Meal-Type$$anon$5.js";
var $p;
function $s_Lmealorama_MealType$__breakfast__Lmealorama_MealType() {
  $m_Lmealorama_MealType$();
  return $t_Lmealorama_MealType$__breakfast;
}
export { $s_Lmealorama_MealType$__breakfast__Lmealorama_MealType as $s_Lmealorama_MealType$__breakfast__Lmealorama_MealType };
function $s_Lmealorama_MealType$__lunch__Lmealorama_MealType() {
  $m_Lmealorama_MealType$();
  return $t_Lmealorama_MealType$__lunch;
}
export { $s_Lmealorama_MealType$__lunch__Lmealorama_MealType as $s_Lmealorama_MealType$__lunch__Lmealorama_MealType };
function $s_Lmealorama_MealType$__dinner__Lmealorama_MealType() {
  $m_Lmealorama_MealType$();
  return $t_Lmealorama_MealType$__dinner;
}
export { $s_Lmealorama_MealType$__dinner__Lmealorama_MealType as $s_Lmealorama_MealType$__dinner__Lmealorama_MealType };
function $s_Lmealorama_MealType$__snack__Lmealorama_MealType() {
  $m_Lmealorama_MealType$();
  return $t_Lmealorama_MealType$__snack;
}
export { $s_Lmealorama_MealType$__snack__Lmealorama_MealType as $s_Lmealorama_MealType$__snack__Lmealorama_MealType };
function $s_Lmealorama_MealType$__other__Lmealorama_MealType() {
  $m_Lmealorama_MealType$();
  return $t_Lmealorama_MealType$__other;
}
export { $s_Lmealorama_MealType$__other__Lmealorama_MealType as $s_Lmealorama_MealType$__other__Lmealorama_MealType };
/** @constructor */
function $c_Lmealorama_MealType$() {
  this.alW = null;
  $n_Lmealorama_MealType$ = this;
  $t_Lmealorama_MealType$__breakfast = new $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00241.$c_Lmealorama_MealType$$anon$1();
  $t_Lmealorama_MealType$__lunch = new $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00242.$c_Lmealorama_MealType$$anon$2();
  $t_Lmealorama_MealType$__dinner = new $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00243.$c_Lmealorama_MealType$$anon$3();
  $t_Lmealorama_MealType$__snack = new $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00244.$c_Lmealorama_MealType$$anon$4();
  $t_Lmealorama_MealType$__other = new $j_mealorama$002e$002dMeal$002dType$0024$0024anon$00245.$c_Lmealorama_MealType$$anon$5();
  this.alW = new ($j_mealorama$002e$002dMeal$002dType.$d_Lmealorama_MealType.r().C)([$s_Lmealorama_MealType$__breakfast__Lmealorama_MealType(), $s_Lmealorama_MealType$__lunch__Lmealorama_MealType(), $s_Lmealorama_MealType$__dinner__Lmealorama_MealType(), $s_Lmealorama_MealType$__snack__Lmealorama_MealType(), $s_Lmealorama_MealType$__other__Lmealorama_MealType()]);
}
export { $c_Lmealorama_MealType$ as $c_Lmealorama_MealType$ };
$p = $c_Lmealorama_MealType$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MealType$;
/** @constructor */
function $h_Lmealorama_MealType$() {
}
export { $h_Lmealorama_MealType$ as $h_Lmealorama_MealType$ };
$h_Lmealorama_MealType$.prototype = $p;
$p.a4g = (function() {
  return this.alW.a6();
});
$p.aI6 = (function(\u03b4name) {
  switch (\u03b4name) {
    case "breakfast": {
      return $s_Lmealorama_MealType$__breakfast__Lmealorama_MealType();
      break;
    }
    case "lunch": {
      return $s_Lmealorama_MealType$__lunch__Lmealorama_MealType();
      break;
    }
    case "dinner": {
      return $s_Lmealorama_MealType$__dinner__Lmealorama_MealType();
      break;
    }
    case "snack": {
      return $s_Lmealorama_MealType$__snack__Lmealorama_MealType();
      break;
    }
    case "other": {
      return $s_Lmealorama_MealType$__other__Lmealorama_MealType();
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), ("enum mealorama.MealType has no case with name: " + \u03b4name));
    }
  }
});
var $d_Lmealorama_MealType$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealType$, "mealorama.MealType$", ({
  Gu: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_MealType$ as $d_Lmealorama_MealType$ };
var $n_Lmealorama_MealType$;
function $m_Lmealorama_MealType$() {
  if ((!$n_Lmealorama_MealType$)) {
    $n_Lmealorama_MealType$ = new $c_Lmealorama_MealType$();
  }
  return $n_Lmealorama_MealType$;
}
export { $m_Lmealorama_MealType$ as $m_Lmealorama_MealType$ };
var $t_Lmealorama_MealType$__breakfast = null;
function $u_Lmealorama_MealType$__breakfast(x) {
  $t_Lmealorama_MealType$__breakfast = x;
}
export { $t_Lmealorama_MealType$__breakfast as $t_Lmealorama_MealType$__breakfast, $u_Lmealorama_MealType$__breakfast as $u_Lmealorama_MealType$__breakfast };
var $t_Lmealorama_MealType$__lunch = null;
function $u_Lmealorama_MealType$__lunch(x) {
  $t_Lmealorama_MealType$__lunch = x;
}
export { $t_Lmealorama_MealType$__lunch as $t_Lmealorama_MealType$__lunch, $u_Lmealorama_MealType$__lunch as $u_Lmealorama_MealType$__lunch };
var $t_Lmealorama_MealType$__dinner = null;
function $u_Lmealorama_MealType$__dinner(x) {
  $t_Lmealorama_MealType$__dinner = x;
}
export { $t_Lmealorama_MealType$__dinner as $t_Lmealorama_MealType$__dinner, $u_Lmealorama_MealType$__dinner as $u_Lmealorama_MealType$__dinner };
var $t_Lmealorama_MealType$__snack = null;
function $u_Lmealorama_MealType$__snack(x) {
  $t_Lmealorama_MealType$__snack = x;
}
export { $t_Lmealorama_MealType$__snack as $t_Lmealorama_MealType$__snack, $u_Lmealorama_MealType$__snack as $u_Lmealorama_MealType$__snack };
var $t_Lmealorama_MealType$__other = null;
function $u_Lmealorama_MealType$__other(x) {
  $t_Lmealorama_MealType$__other = x;
}
export { $t_Lmealorama_MealType$__other as $t_Lmealorama_MealType$__other, $u_Lmealorama_MealType$__other as $u_Lmealorama_MealType$__other };
//# sourceMappingURL=mealorama.-Meal-Type$.js.map
